const getDefaultState = () => ({
  approval: {
    loading: false,
    error: false,
    items: {
      offset: 0,
      hasMore: true,
      reviews: [],
    },
  },
  filter: {
    loading: false,
    error: false,
    items: [],
    selectedBrands: [],
    selectedDomains: [],
    sites: [],
    selectedSites: [],
  },
  bulk: {
    reviewIds: [],
  },
  overview: {
    loading: false,
    error: false,
    items: {
      approved: 0,
      disapproved: 0,
      unresolved: 0,
    },
    approvalStatusFilter: 'unresolved',
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/review/defaultState.js